module.exports = __webpack_public_path__ + "assets/img/donghai.6c3780e5.png";